<template>
  <v-main>
    <v-container fluid class="pa-0">
      <router-view />
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'PublicLayout',
}
</script>
